import { Component, Input, OnInit } from '@angular/core';
import { HtmlTextService } from '../../services/html-text.service';
import { CurrencyPipe } from '@angular/common';

@Component({
  selector: 'acct-msg',
  templateUrl: './acct-msg.component.html',
  styleUrls: ['./acct-msg.component.scss']
})
export class AcctMsgComponent implements OnInit {
  @Input() metadata: any;
  data: any;

  constructor(
    private _htmlTextService: HtmlTextService,
    private _currencyPipe: CurrencyPipe
  ) { }

  ngOnInit() {
    if (this.metadata["msgCd"]) {
      let serviceUrl = '/wps/wcm/myconnect/ucd_content/sa-acctmsg/' + this.metadata["msgCd"];
      this._htmlTextService.getHTMLText(serviceUrl).subscribe((serviceData) => {
        this.processData(serviceData)
      });
    }
  }

  processData(inputdata) {
    if (inputdata) {
      try {
        let wcmdata = inputdata.replace(/(\r|\n|\t|\f)/g, "")
          .replace(/dir="ltr"/gi, "")
          .replace(/dir=\\"ltr\\"/gi, "")
          .replace(/dir="\\&quot;ltr\\&quot;"/gi, "")
          .replace(/[\u0000-\u0019]+/g, "")
          .replace(/\&nbsp\;/gi, " ");
        let preCheckData = JSON.parse(wcmdata);
        if (preCheckData.dynamic) {
          this.processDynamicData(wcmdata)
        } else {
          this.data = preCheckData;
        }
      } catch (e) {
        console.warn("acct-msg parsing error: ", e);
      }
    }
  }

  processDynamicData(wcmdata) {
    try {
      let processedData = wcmdata.replace(/\$\{[^\}]*\}/g, (match) => {
        match = match.replace(/(\$\{|\})/g, '');
        if (/\|\s*currency/gi.test(match)) {
          match = match.split(/\|\s*currency/gi)[0].trim();
          return this._currencyPipe.transform(this.metadata[match] || 0);
        }
        return this.metadata[match] || '';
      });
      this.data = JSON.parse(processedData);
    } catch (e) {
      console.warn("acct-msg dynamic content parsing error: ", e);
    }
  }

}
